/** @format */

import React from 'react';
import { Link } from 'react-router-dom';
import Button from 'react-bootstrap/Button';

export default function RegularHeader(props) {
  const {
    buttonText,
    homepageUrl,
    getButtonColor,
    registerAsBrokerUrl,
    hideHeaderButtons
  } = props;

  return (
    <>
      <div className='header'>
        <div className='header-left-container'>
          <a href={homepageUrl} className='logo' target='_self'>
            <div className='logo-fria-maklare-dark' />
          </a>
        </div>
        <div className='header-middle-container'></div>
        <div className='header-right-container'>
          {!hideHeaderButtons &&
            buttonText.map((item, key) => (
              <div className={`header-button-item`} key={key}>
                {key === 1 && (
                  <a href={registerAsBrokerUrl} target='_self'>
                    <Button className={`btn btn-${getButtonColor(key)}`}>
                      {item.text}
                    </Button>
                  </a>
                )}
                {key === 0 && (
                  <Link to={item.props.url}>
                    <Button className={`btn btn-${getButtonColor(key)}`}>
                      {item.text}
                    </Button>
                  </Link>
                )}
              </div>
            ))}
        </div>
      </div>
    </>
  );
}
